import { router } from "@inertiajs/react";
import * as Sentry from "@sentry/react";

declare global {
  interface Window {
    AuthenticatedUser?: {
      id: string;
      email: string;
    };
  }
}

const environment =
  document.querySelector("meta[name='env']")?.getAttribute("content") || undefined;

function sentryEnabled() {
  return environment !== "development" && environment !== "test";
}

export function initSentry() {
  if (!sentryEnabled()) return;

  const client = Sentry.init({
    dsn: "https://3df3cd0098f53ace664569161a6b6e7b@o4508637167878144.ingest.us.sentry.io/4508637322805248",
    integrations: [
      Sentry.browserTracingIntegration({
        instrumentNavigation: false,

        // inertia events only trigger for navigation, so we still want to rely on the default
        // instrumentation for page load
        instrumentPageLoad: true,
      }),
      Sentry.replayIntegration(),
    ],
    environment,
    // Tracing
    tracesSampleRate: 0.01,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/preview\.teeba-calculator\.com/,
      /^https:\/\/app\.teeba-calculator\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  if (client) {
    // Inertiajs events only trigger for navigation, not on page load.
    router.on("start", (event) => {
      Sentry.startBrowserTracingNavigationSpan(client, {
        op: "navigation",
        name: event.detail.visit.url.pathname,
        attributes: {
          [Sentry.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "route",
        },
      });
    });
  }
}
